import { createSlice } from "@reduxjs/toolkit";
import {
  changeEmailProfileData,
  changePassword,
  editProfileData,
  fetchPlatforms,
  fetchProfileData,
  fetchStates,
} from "../thunks/profileThunk.tsx";
import { ProfileState } from "../types/profileTypes.tsx";

const initialState: ProfileState = {
  isLoading: false,
  isLoadingEdit: false,
  isLoadingStates: false,
  isLoadingPlatforms: false,
  isLoadingEmailChange: false,
  isLoadingPasswordChange: false,
  profile: null,
  countries: null,
  states: null,
  roles: null,
  platforms: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setCountries: (state, action) => {
      state.countries = action.payload;
    },
    setStates: (state, action) => {
      state.states = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProfileData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProfileData.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.profile = action.payload;
        state.roles = action.payload.roles;
      }
    });
    builder.addCase(editProfileData.pending, (state) => {
      state.isLoadingEdit = true;
    });
    builder.addCase(editProfileData.fulfilled, (state, action) => {
      state.isLoadingEdit = false;
      if (action.payload) {
        state.profile = action.payload;
        state.roles = action.payload.roles;
      }
    });
    builder.addCase(changePassword.pending, (state) => {
      state.isLoadingPasswordChange = true;
    });
    builder.addCase(changePassword.fulfilled, (state) => {
      state.isLoadingPasswordChange = false;
    });
    builder.addCase(fetchStates.pending, (state) => {
      state.isLoadingStates = true;
    });
    builder.addCase(fetchStates.fulfilled, (state, action) => {
      state.isLoadingStates = false;
      if (action.payload) {
        state.states = action.payload;
      }
    });
    builder.addCase(fetchPlatforms.pending, (state) => {
      state.isLoadingPlatforms = true;
    });
    builder.addCase(fetchPlatforms.fulfilled, (state, action) => {
      state.isLoadingPlatforms = false;
      if (action.payload) {
        state.platforms = action.payload;
      }
    });
    builder.addCase(changeEmailProfileData.pending, (state) => {
      state.isLoadingEmailChange = true;
    });
    builder.addCase(changeEmailProfileData.fulfilled, (state, action) => {
      state.isLoadingEmailChange = false;
      if (action.payload) {
        state.profile = state.profile
          ? { ...state.profile, email: action.payload }
          : null;
      }
    });
  },
});

export const { setCountries, setStates } = profileSlice.actions;
